<template>
  <v-app-bar
    color="white"
    class="toolbar-quotation__content elevation-0 px-0 px-sm-5"
  >
    <v-row>
      <v-col cols="12" class="toolbar-quotation__col">
        <div
          v-for="(item, key) of stepsQuotation"
          :key="key"
          class="toolbar-quotation__step"
        >
          <div class="toolbar-quotation__line-wrap-left" v-if="key > 0" />
          <v-avatar
            :class="[
              colorStep(item),
              'toolbar-quotation__step-icon',
              { 'toolbar-quotation__step--clickable': isStepClickable(item) }
            ]"
            size="30"
            :role="navigationEnabled ? 'button' : null"
            :tabindex="isStepClickable(item) ? 0 : null"
            :aria-label="navigationEnabled ? item.name : null"
            :aria-disabled="navigationEnabled ? !isStepClickable(item) : null"
            @click="onStepClick(item)"
            @keydown.enter.prevent="onStepClick(item)"
            @keydown.space.prevent="onStepClick(item)"
          >
            <v-icon v-if="showIcon(item)" size="17">
              {{ iconStep(item) }}
            </v-icon>
          </v-avatar>
          <div
            class="toolbar-quotation__line-wrap-right"
            v-if="key < stepsQuotation.length - 1"
          />
        </div>
      </v-col>
      <v-col cols="12" class="toolbar-quotation__col">
        <div
          v-for="(item, key) of stepsQuotation"
          :key="key"
          class="toolbar-quotation__step"
        >
          <v-toolbar-title
            :class="[
              colorText(item),
              'justify-center d-none d-sm-flex',
              { 'toolbar-quotation__step--clickable': isStepClickable(item) }
            ]"
            @click="onStepClick(item)"
          >
            {{ item.name }}
          </v-toolbar-title>
        </div>
      </v-col>
    </v-row>
  </v-app-bar>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("quotation", ["currentQuotationStep"])
  },
  methods: {
    isStepClickable(item) {
      return (
        this.navigationEnabled &&
        !this.disabled &&
        item.step <= this.maxStep &&
        item.step !== this.currentQuotationStep.step
      );
    },
    onStepClick(item) {
      if (this.isStepClickable(item)) {
        this.$emit("clickStep", item);
      }
    },
    colorStep(item) {
      const currentStep = this.currentQuotationStep;
      const color =
        (currentStep.step < item.step && "white") ||
        (currentStep.step > item.step && "green") ||
        "yellow";
      return `toolbar-quotation__background-${color}`;
    },
    colorText(item) {
      const currentStep = this.currentQuotationStep;
      const color =
        currentStep.step < item.step ? "lightBlue--text" : "primary--text";
      return `toolbar-quotation__text font-weight-medium ${color}`;
    },
    iconStep(item) {
      const currentStep = this.currentQuotationStep;
      const icon =
        (currentStep.step < item.step && null) ||
        (currentStep.step > item.step && "fa-check") ||
        "fa-ellipsis-h";
      return icon;
    },
    showIcon(item) {
      const currentStep = this.currentQuotationStep;
      return currentStep.step >= item.step;
    }
  },
  props: {
    navigationEnabled: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxStep: {
      type: Number,
      default: 0
    },
    stepsQuotation: {
      type: Array
    }
  }
};
</script>
<style lang="sass">
.toolbar-quotation__
  &background-white
    border: 2px solid #E5E5ED
    background-color: #FFFFFF
  &background-green
    background-color: #49DCBB
  &background-yellow
    background-color: #FFEDB9
  &content
    z-index: 6
    height: 65px
    align-items: center
  &text
    font-size: 14px
    @media(max-width:960px)
      font-size: 12px
  &col
    display: flex
    flex-wrap: wrap
  &step
    flex: 1
    justify-content: center
    text-align: center
    position: relative
  &line-wrap-left
    width: 50%
    border: 1px solid rgba(213,213,224,0.51)
    top: 50%
    position: absolute
  &line-wrap-right
    width: 50%
    border: 1px solid rgba(213,213,224,0.51)
    top: 50%
    position: absolute
    right: 0
  &step--clickable
    cursor: pointer
    &:hover
      opacity: 0.8
  &step-icon
    z-index: 1
</style>
